import { render, staticRenderFns } from "./BossDetail.vue?vue&type=template&id=24d15c30"
import script from "./BossDetail.vue?vue&type=script&lang=js"
export * from "./BossDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports